export default __webpack_public_path__ + "img/2_10-1775e8d7.png";